module.exports = __webpack_public_path__ + "static/media/anne-hathaway-win.630a515b.jpg";